import { keepPreviousData, useQuery } from '@tanstack/react-query';
import DataApiClient from 'src/utils/DataApiClient';
import { QueryDisabledError } from 'src/utils/error/QueryDisabledError';
import { createQueryKey } from 'src/utils/query/createQueryKey';
import { AccountEarnSnapshot } from 'src/hooks/query/snapshots/account/types';
import { SNAPSHOTS_QUERY_STALE_TIME } from 'src/hooks/query/snapshots/consts';

function accountEarnSnapshotsQueryKey(userAccount?: string, days?: number) {
	return createQueryKey('accountEarnSnapshots', userAccount, days);
}

interface Params {
	userAccount: string | undefined;
	days: number;
}

interface ResponseData {
	snapshots: AccountEarnSnapshot[];
}

export default function useAccountEarnSnapshots({ userAccount, days }: Params) {
	const disabled = !userAccount || days <= 0;

	return useQuery({
		queryKey: accountEarnSnapshotsQueryKey(userAccount, days),
		queryFn: () => {
			if (disabled) {
				throw new QueryDisabledError();
			}

			return DataApiClient.fetchSnapshotData<ResponseData>({
				level: 'user',
				resource: 'earn',
				params: {
					userAccount,
					days,
				},
			});
		},
		enabled: !disabled,
		placeholderData: disabled ? undefined : keepPreviousData,
		staleTime: SNAPSHOTS_QUERY_STALE_TIME,
	});
}
